<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">On Killing</h1>
<h2 class="subtitle">The Psychological Cost of Learning to Kill in War and Society</h2>
<p class="author">Revised Edition</p>
<p class="author">Lt. Col. Dave Grossman</p>
<p class="colophon"><img alt="Open Road logo" src="images/logo2.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section1.vue?2b7ba646